import * as React from 'react';

interface ILabelProps extends React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {}
/**
 * Label is a wrapper for `<label>` html element.
 * It is usually used within the `FormGroup` component.
 */
export const Label: React.FunctionComponent<ILabelProps> = (props) => <label {...props} />;

export default Label;
